var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "app_setting_cla" },
      _vm._l(_vm.appSettingArray, function(item, index) {
        return _c("div", { key: index, staticClass: "app_setting_item" }, [
          _c(
            "div",
            { staticClass: "app_setting_title" },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    width: "280px",
                    overflow: "hidden",
                    "text-overflow": "ellipsis"
                  }
                },
                [_vm._v(_vm._s(item.name))]
              ),
              _vm._v(" "),
              _c("el-switch", {
                on: {
                  change: function($event) {
                    return item.fn(item.switchs)
                  }
                },
                model: {
                  value: item.switchs,
                  callback: function($$v) {
                    _vm.$set(item, "switchs", $$v)
                  },
                  expression: "item.switchs"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "app_setting_des" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("developer.pushDes")) +
                _vm._s(item.des) +
                "\n      "
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5200b7de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5200b7de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appSetting/appFnSetting.vue
// module id = null
// module chunks = 